import { modifier } from '@styles/mixins'
import { colors } from '@styles/vars'
import _ from 'lodash'
import React from 'react'
import styled, { css } from 'styled-components'

export default function Stars({ score, cast, border = colors.border }: Props) {
    const stars = _.range(10)

    return (
        <Container>
            {stars.map((value, idx) => 
                <Star 
                border={border}
                key={idx + 1} 
                active={(score || 0) >= (idx + 1)} 
                onClick={() => cast(idx + 1)}>
                    {idx + 1}
                </Star>
            )}
        </Container>
    )
}

// STYLES
const Container = styled.div`
    display: flex;
    justify-content: center;
`

const Star = styled.div<{ active: boolean, border: string }>`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 30px;
    width: 100%;
    color: ${colors.black};
    background: ${colors.white};
    border-top: 1px solid ${props => props.border};
    border-bottom: 1px solid ${props => props.border};
    cursor: pointer;
    transition: .2s ease-out;

    &:hover {
        background: ${colors.greyBackground};
    }

    ${modifier("active", css`
        background: ${colors.black};
        color: ${colors.white};

        &:hover {
            background: ${colors.darkGrey};
        }
    `)}

    &:first-child {
        border-left: 1px solid ${props => props.border};
        border-radius: 24px;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
        padding-left: 4%;
        width: 120%;
    }

    &:last-child {
        border-right: 1px solid ${props => props.border};
        border-radius: 24px;
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
        padding-right: 3%;
        width: 120%;
    }
`

// TYPES
interface Props {
    cast: (score: number) => void
    score?: number
    border?: string
}